module.exports = __webpack_public_path__ + "images/fontawesome-webfont.912ec66d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 333
// module chunks = 0